import { useEffect } from 'react'
import type { RouteObject } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { migrarAssinaturas } from '@/utils/migrarAssinaturas'
import { useRoutes } from 'react-router-dom'
import DashboardLayout from '@/components/layout/DashboardLayout'
import { SetupAdmin } from '@/components/SetupAdmin'
import { AuthProvider } from '@/contexts/AuthContext'
import Cidades from '@/pages/Cidades'
import Configuracoes from '@/pages/Configuracoes'
import Dashboard from '@/pages/Dashboard'
import Login from '@/pages/Login'
import MeuPerfil from '@/pages/MeuPerfil'
import Protocolos from '@/pages/Protocolos'
import ProtocolosExcluidos from '@/pages/ProtocolosExcluidos'
import Secretarias from '@/pages/Secretarias'
import SubLocais from '@/pages/SubLocais'
import Usuarios from '@/pages/Usuarios'

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  { path: '/', element: <Login /> },
  {
    element: <DashboardLayout />,
    children: [
      { path: '/dashboard', element: <Dashboard /> },
      { path: '/perfil', element: <MeuPerfil /> },
      { path: '/protocolos', element: <Protocolos /> },
      { path: '/protocolos/excluidos', element: <ProtocolosExcluidos /> },
      { path: '/sublocais', element: <SubLocais /> },
      { path: '/usuarios', element: <Usuarios /> },
      { path: '/cidades', element: <Cidades /> },
      { path: '/secretarias', element: <Secretarias /> },
      { path: '/configuracoes', element: <Configuracoes /> },
    ],
  },
]

function App() {
  const element = useRoutes(routes)

  // Preenche a assinatura autorizadora nos requerimentos antigos (executa uma vez).
  useEffect(() => {
    migrarAssinaturas()
  }, [])

  return (
    <AuthProvider>
      <SetupAdmin />
      <Toaster position="top-right" />
      {element}
    </AuthProvider>
  )
}

export default App
